<div fxLayout="column" class="announcement-display-container">

  <ng-container *ngIf="isLoading then ShowLoading else ShowAnnouncement"></ng-container>

  <ng-template #ShowLoading>
    <app-loading></app-loading>
  </ng-template>

  <ng-template #ShowAnnouncement>
    <!-- Modern Centered Title -->
    <div class="announcement-header" fxLayout="column" fxLayoutAlign="center center">
      <div class="title-icon">
        <mat-icon>campaign</mat-icon>
      </div>
      <h1 class="announcement-title">{{announcement.title}}</h1>
      <div class="title-underline"></div>
    </div>

    <!-- Centered Content -->
    <div fxLayout="row" fxLayoutAlign="center center center" class="announcement-body">
      <div fxLayout="column" [innerHTML]="transform(htmlContent)" class="announcement-content"></div>
    </div>

  </ng-template>
</div>
